<footer class="bg-light p-3 text-center">
    <div class="logo"></div>
    <p>
      Sample project provided by
      <a href="https://auth0.com">Auth0</a>
    </p>
  </footer>
